import { render } from "./areaDashboard.vue?vue&type=template&id=6e87f05a"
import script from "./areaDashboard.vue?vue&type=script&lang=js"
export * from "./areaDashboard.vue?vue&type=script&lang=js"

import "./areaDashboard.vue?vue&type=style&index=0&id=6e87f05a&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__